/* angular:styles/component:css;a2b95fff277c6e260c3a5867835204e8114bbcfc5ccb0a8b0ddb9f46fe646ca5;/opt/atlassian/pipelines/agent/build/src/app/tab-signals/edit-signal.component.ts */
.value-edit {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  flex-grow: 1;
  flex-basis: 0;
}
ion-item {
  --highlight-background: transparent !important;
}
ion-label {
  flex-shrink: 0;
}
/*# sourceMappingURL=edit-signal.component.css.map */
